import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		width: 17,
		height: 17,
		x: .5,
		y: .5,
		fill: "#fff",
		stroke: "currentColor",
		rx: 1.5
	})
});
export default SvgCheckbox;
